import { render, staticRenderFns } from "./BL.vue?vue&type=template&id=52d3844c&lang=html&"
import script from "./BL.vue?vue&type=script&lang=js&"
export * from "./BL.vue?vue&type=script&lang=js&"
import style0 from "./BL.vue?vue&type=style&index=0&id=52d3844c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports